var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy-line"},[_c('input',{staticClass:"copy-line__input",attrs:{"aria-label":"Значение для копирования","readonly":"readonly","type":"text"},domProps:{"value":_vm.value}}),_c('button',{staticClass:"copy-line__button",attrs:{"title":"Скопировать значение","type":"button"},on:{"click":_vm.onCopy}})])
}
var staticRenderFns = []

export { render, staticRenderFns }